module.exports = __webpack_public_path__ + "static/media/bvlgari-omnia-crystalline-big.afdc907e.png";